export const LOGO = require("./images/logo.png");
export const LOGOWITHBG = require("./images/logo-with-bg.png");
export const MISSION_CENTER_LOGO = require("./images/mission_center_logo.png");
export const COURT_ORDER = require("./images/order.png");
export const PAPERS = require("./images/papers.png");
export const SHAKEHAND = require("./images/shake-hand.png");
export const COMBAT = require("./images/combat.png");
export const CHAMPION = require("./images/champion.png");
export const EMPOWER = require("./images/empower.png");
export const JUSTICE = require("./images/justice.png");
export const PURSUIT = require("./images/pursuit.png");
export const FOCUSED = require("./images/focused.png");
export const GLOBESMALL = require("./images/globe-small.png");
export const GLOBE = require("./images/globe.png");
export const GLOBALSTANDARD = require("./images/global-standard.png");
export const FORM = require("./images/form.png");
export const EMAIL = require("./images/email.png");
export const CALL = require("./images/call.png");
export const FACEBOOK = require("./images/facebook.png");
export const TWITTER = require("./images/twitter.png");
export const INSTAGRAM = require("./images/instagram.png");
export const LINKEDIN = require("./images/linkedin.png");
export const ABOUT_US = require("./images/about-us-center.png");
// export const ATLAS_GROUP = require("./images/atlas-group.png");
export const ATLAS_GROUP = require("./images/atlas-group_img_full.png.png");

export const PROFESSIONALISM = require("./images/professionalism.png");
export const TRUST = require("./images/trust.png");
export const INTEGRITY = require("./images/integrity.png");
export const MEET_THE_TEAM = require("./images/meet-the-team.png");
export const JOHN = require("./images/john.png");
export const OUR_VALUES = require("./images/our-values-center.png");
// export const HEAVIER = require("./images/heavier.png");
export const HEAVIER = require("./images/heavier_full_img.png");

export const TRANSPARENCY = require("./images/transparency.png");
export const EXCELLENCE = require("./images/excellence.png");
export const GLOBAL_EXPERTISE = require("./images/global-expertise.png");
export const TEAM_WORK = require("./images/teamwork.png");
export const COMMITMENT = require("./images/commitment.png");
export const APPROACH = require("./images/approach.png");
export const INNOVATION = require("./images/innovation.png");

export const HOME_OUR_MISSION_IMG = require("./images/home__our-mission.png");
export const HOME_GLOBAL_SMALL = require("./images/home_sec_3_global_left.png");
export const HOME_GLOBAL_BIG = require("./images/home_sec_3_global_right.png");
export const HOME_ABOUT_US = require("./images/home_sec_3_aboutUs.png");

export const HOME_INTEGRITY = require("./images/home_sec_4_Integrity.png");
export const HOME_TRANSPARENCY = require("./images/home_sec_4_Transparency.png");
export const HOME_king = require("./images/home_sec_4_Professionalism.png");

export const HOME_SERVICES = require("./images/home_sevices_img.png");

export const HOME_SERVICES_1 = require("./images/home_services_1.png");
export const HOME_SERVICES_2 = require("./images/home_services_2.png");
export const HOME_SERVICES_3 = require("./images/home_services_3.png");
export const HOME_SERVICES_4 = require("./images/home_services_4.png");
export const HOME_SERVICES_5 = require("./images/home_services_5.png");
export const HOME_SERVICES_6 = require("./images/home_services_6.png");
export const SERVICES = require("./images/services_center.png");
// export const JUSTICE_ORDER = require("./images/justice-order.png");
export const JUSTICE_ORDER = require("./images/justice-order.png_full_img.png");

export const ASSET_RECOVERY = require("./images/asset-recovery.png");
export const FINANCIAL_FRAUD = require("./images/financial-fraud.png");
export const CROSS_BORDER_DISPUTE = require("./images/cross-border.png");
export const LOST_INVESTMENT = require("./images/lost-investment.png");
export const FRAUD_RECOVER = require("./images/fraud-recover.png");
export const CORRECT = require("./images/correct.png");
export const INTERNATIONAL_LITIGATION_LOGO = require("./images/internation-litigation-logo.png");
export const INTERNATIONAL_LITIGATION_ICON = require("./images/international-litigation-icon.png");
export const CORPORATE_FRAUD_SOLUTION_ICON = require("./images/corporate-fraud-solution-icon.png");
export const CORPORATE_FRAUD_SOLUTION_LOGO = require("./images/corporate-fraud-solution-logo.png");
export const CONSULTING_ICON = require("./images/consulting-icon.png");
export const CONSULTING_LOGO = require("./images/consulting-logo.png");
export const DIGITAL_ICON = require("./images/digital-icon.png");
export const DIGITAL_LOGO = require("./images/digital-logo.png");
export const ASSET_TRACING_ICON = require("./images/asset-tracing-icon.png");
export const ASSET_TRACING_LOGO = require("./images/asset-tracing-logo.png");
export const WHY_US_LOGO = require("./images/why-us-logo.png");
export const TWONHALL = require("./images/townhall.png");
export const HOME_SEC_6_IMG = require("./images/home_sec_6_tite_img.png");
export const HOME_WORK_WITH_1 = require("./images/home_work_with_img_1.png");
export const HOME_WORK_WITH_2 = require("./images/home_work_with_img_2.png");
export const HOME_WORK_WITH_3 = require("./images/home_work_with_img_3.png");
export const HOME_WORK_WITH_4 = require("./images/home_work_with_img_4.png");
// export const HOME_SEC_7_TITLE_IMG = require("./images/home_sec_7_title_img.png");
export const HOME_SEC_7_TITLE_IMG = require("./images/home_sec_7_title_img_text_new.png");

export const START = require("./images/star.png");
export const H_SEC_7_PROFILE = require("./images/Ellipse 1.png");
export const H_SEC_7_LOGO = require("./images/home_sec_7_logo.png");
export const H_SEC_8_TITLE_IMG = require("./images/list_of_view.png");
export const H_SEC_8_LIST = require("./images/home_sec_8_list.png");
export const FAQ_TITLE_IMG = require("./images/faq_title_img.png");
export const FAQ_NOTE_BOOK = require("./images/faq_note_book.png");
export const ACCORDION_OPEN_MARK = require("./images/accordion_open_mark.png");
export const ACCORDION_CLOSE_MARK = require("./images/accordion_close_mark.png");
export const WHY_SEC_2_SMALL_IMG_1 = require("./images/why_sec_2_img_1.png");
export const WHY_SEC_2_SMALL_IMG_2 = require("./images/why_sec_2_img_2.png");
export const WHY_SEC_3_SMALL_IMG_1 = require("./images/why_sec_3_img_1.png");
export const WHY_SEC_3_SMALL_IMG_2 = require("./images/why_sec_3_img_2.png");
export const WHY_RELENTLESS = require("./images/why_sec_2_relentless.png");
export const WHY_BEYOND_RECOVERY = require("./images/why_sec_3_beyond_recovery.png");
export const WHY_SEC_4_SMALL_IMG_1 = require("./images/why_sec_4_img_1.png");
export const WHY_SEC_4_BIG_IMG = require("./images/why_sec_4_img.png");
export const WHY_SEC_5_SMALL_IMG_1 = require("./images/why_sec_5_img_1.png");
export const WHY_SEC_5_SMALL_IMG_2 = require("./images/why_sec_5_img_2.png");
export const WHY_SEC_5_CHECK_MARK = require("./images/why_us_sec_5_check_mark.png");

export const WHY_SEC_6_TITLE_IMG = require("./images/why_us_sec_6_title_img.png");

export const WHY_SEC_6_SMALL_IMG_1 = require("./images/why_us_sec_6_small_img_1.png");
export const WHY_SEC_6_SMALL_IMG_2 = require("./images/why_us_sec_6_small_img_2.png");
export const WHY_SEC_6_SMALL_IMG_3 = require("./images/why_us_sec_6_small_img_3.png");
